import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { BrandMark } from '@/components/Brand';
import { Button } from '@/components/ui';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 px-6 text-center">
      <BrandMark className="h-16 w-16" />
      <div>
        <p className="text-sm font-semibold uppercase tracking-widest text-primary">404</p>
        <h1 className="mt-2 text-2xl font-bold tracking-tight">Halaman tidak ditemukan</h1>
        <p className="mt-2 max-w-md text-sm text-muted-foreground">
          Halaman yang Anda cari mungkin telah dipindahkan atau tidak tersedia lagi.
        </p>
      </div>
      <Button asChild>
        <Link to="/">
          <Home className="h-4 w-4" /> Kembali ke Beranda
        </Link>
      </Button>
    </div>
  );
}
